function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("polyline", {
  fill: "none",
  stroke: "#00143A",
  strokeWidth: 6,
  points: "13 17 5 9.5 13 2"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/leftArrow.6c62939a.svg";
export { SvgComponent as ReactComponent };